import { css } from '@emotion/react';

const holdingsContainerStyles = css`
    .pie-charts-container {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        justify-content: space-between;
    }
`;

export default holdingsContainerStyles;
